import React, { useEffect, useRef, useState } from "react";
import ReactPlayer from "react-player";
import $ from 'jquery';
import _ from 'underscore';

import { faPause, faPlay } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import FadeLoader from 'react-spinners/FadeLoader';
import { intervalLogging, stopLogging } from "../common/logger";

export default function VideoClip(props){

    const videoRef = useRef(null);

    var currentPlayingTime = 0;
    var durationTime = 0;

    const [countTime, setCountTime] = useState(0);

    useEffect(() => {
        startTime();
    },[props.frontTime]);

    useEffect(() => {
        // 영상이 선택되어 있을 경우에만 방향키 이벤트 등록
        if(props.dataKey){
            window.addEventListener("keydown", keyDownHandler);
            return () => window.removeEventListener("keydown", keyDownHandler);
        }
    },[props.dataKey, props.playing]);

    const keyDownHandler = (evt) => {
        var playingType = props.getPlayingType();

        // 방향키 & 스페이스바 눌렀을 때 스크롤 이동하지 않도록 해주기 위함
        // evt.preventDefault();

        if(evt.key == 'ArrowUp'){
            // 위 화살표 누름
            evt.preventDefault();
            playPrevClipHandler();
            if(props.playing == false){
                // 만약 키보드 이벤트 발생 시 영상이 일시정지 상태였다면
                props.setIcon(faPlay);
                $("#screenController").animate({opacity:0}, 300);
                $('#playIcon').animate({opacity:0}, 300);
            }

        } else if(evt.key == 'ArrowDown'){
            // 아래 화살표 누름
            evt.preventDefault();
            playNextClipHandler();
            if(props.playing == false){
                // 만약 키보드 이벤트 발생 시 영상이 일시정지 상태였다면
                props.setIcon(faPlay);
                $("#screenController").animate({opacity:0}, 300);
                $('#playIcon').animate({opacity:0}, 300);
            }

        } else if(evt.key == 'ArrowLeft'){
            // 왼쪽 화살표 누름 (playingType이 justplay일 경우에만 동작)
            evt.preventDefault();
            if(playingType === 'justplay'){
                videoRef.current.seekTo(videoRef.current.getCurrentTime() - 3);
                // 이전 로우로 하이라이트를 옮길지 체크하는 함수
                if(videoRef.current.getCurrentTime() < props.frontTime){
                    checkMoveToPrevRow();
                }
            }

        } else if(evt.key == 'ArrowRight'){
            // 오른쪽 화살표 누름 (playingType이 justplay일 경우에만 동작)
            evt.preventDefault();
            if(playingType === 'justplay'){
                videoRef.current.seekTo(videoRef.current.getCurrentTime() + 3);
            }
            
        } else if(evt.code == 'Space'){
            // 스페이스바 누름
            evt.preventDefault();
            if(props.playing === false){
                //만약 영상이 일시정지 상태라면 -> 재생
                props.setPlaying(true);
                props.setIcon(faPlay);
                $("#screenController").animate({opacity:0}, 300);
                $('#playIcon').animate({opacity:0}, 300);
            } else {
                // 만약 영상이 재생중이라면 -> 일시정지
                props.setPlaying(false);
                props.setIcon(faPause);
                $("#screenController").animate({opacity:0.5}, 300);
                $('#playIcon').animate({opacity:0.8}, 300);
            }
        }
    }

    const startTime = () => {
        videoRef.current.seekTo(props.frontTime);
        props.setLoading(false);
        props.setPlaying(true);
    }

    const videoProgress = (param) => {
        var playingType = props.getPlayingType();

        if(playingType !== 'justplay'){
			//만약 재생방법이 3이 아니라면 영상 재생시간동안 재생한 후 멈췄다가 다음 동작 진행 
            if(param.playedSeconds > props.frontTime+props.duration){
                //setPlaying(false);
                restartByTypeHandler(playingType);
            }
		} else if (playingType === 'justplay'){
            //만약 재생 방법이 3이라면 그냥 쭉 재생! (대신 스타일은 적용 필요)
            var currentKey = props.dataKey;
            var playList = props.playList;

            let newKey = 0;
            let currentKeyIdx = 0;

            playList.forEach(function(item,idx){
                newKey = item.gameInfoId+''+item.inning+''+item.inningTb+''+item.batInningTurn+''+item.batPitchSeq;

                if(newKey == currentKey){
                    currentKeyIdx = idx;
                }
            });

            var nextKeyIdx = currentKeyIdx + 1;
            var lastIdx = _.size(playList)-1;

            //만약 다음 영상이 있다면 
            if(nextKeyIdx <= lastIdx){
                havingVideoToPlayBySec(playList, newKey, nextKeyIdx, param.playedSeconds, "moveToNext");
                
            } else {
                //만약 다음 영상이 없다면 
                // if(param.playedSeconds > props.frontTime+props.duration){
                //     props.setPlaying(false);
                //     $("[name='videoClips']").css("backgroundColor","");
                //     if(props.useLang === "en"){
                //         alert("Video playback is complete");
                //     } else {
                //         alert("영상 재생이 완료되었습니다.");
                //     }
                // }
            }

        }

    }
    
    const checkMoveToPrevRow = () => {
        var currentKey = props.dataKey;
        var playList = props.playList;

        let newKey = 0;
        let currentKeyIdx = 0;

        playList.forEach(function(item,idx){
            newKey = item.gameInfoId+''+item.inning+''+item.inningTb+''+item.batInningTurn+''+item.batPitchSeq;

            if(newKey == currentKey){
                currentKeyIdx = idx;
            }
        });

        var prevKeyIdx = currentKeyIdx - 1;
        var firstIdx = 0;

        //만약 이전 영상이 있다면 
        if(prevKeyIdx >= firstIdx){
            havingVideoToPlayBySec(playList, newKey, prevKeyIdx, videoRef.current.getCurrentTime(), "moveToPrev");
        }
    }

    const settingJustPlay = (startTime, pitchInfo, playedSeconds, nextGameYn, moveCode) => {
        //영상의 시작시간(frontTime)과 재생시간(duration) 설정
        var checkBase = pitchInfo.checkBase;
        var hitResultCode = pitchInfo.hitResultCode;
        var beforeOutCount = pitchInfo.beforeOutCount;
        var beforeRunnerState = pitchInfo.beforeRunnerState;
        var outCount = pitchInfo.outCount;
        
        var forStaff = $("#forStaff").is(":checked");
        var f_Time = 2;
        durationTime = 7;
        
        if (typeof(checkBase) != 'undefined' && (checkBase != '0' || checkBase != 0 )) {
            f_Time = 5;
            durationTime = 10;
        }
        
        if (typeof (hitResultCode) != 'undefined' && (hitResultCode != '0' || hitResultCode != 0)) {
            f_Time = 2;
            durationTime = 10;
            if (beforeOutCount !== outCount) {
                //타격 결과가 있고 아웃카운트에 변동이 있을 경우 frontTime = 2 & duration = 17
                durationTime = 17;
            }
        }

        if(forStaff && (beforeRunnerState != 0 || beforeRunnerState!= '0')) {
            f_Time = 7;
            durationTime = 17;
        }
        
        currentPlayingTime = startTime - f_Time;

        if(playedSeconds > props.frontTime + props.duration){
            props.setCaptionState(false);
        }

        if(moveCode === "moveToNext"){
            //스타일이 옮겨지는 타이밍이 조금 늦는 느낌이라 시간에서 -1을 해줌
            if(playedSeconds > currentPlayingTime-1){
                if(nextGameYn == false){
                    //다음 경기가 다른 경기가 아닐 경우
                    return true;
                } else {
                    //다음 경기가 다른 경기일 경우
                    setCountTime(countTime+1);
                    
                    if(countTime > 17){
                        setCountTime(0);
                        return true;
                    }
                }
            }
        } else if(moveCode === "moveToPrev"){
            //스타일이 옮겨지는 타이밍이 조금 늦는 느낌이라 시간에서 -1을 해줌
            if(playedSeconds < currentPlayingTime-1){
                if(nextGameYn == false){
                    //다음 경기가 다른 경기가 아닐 경우
                    return true;
                } else {
                    //다음 경기가 다른 경기일 경우
                    setCountTime(countTime+1);
                    
                    if(countTime > 17){
                        setCountTime(0);
                        return true;
                    }
                }
            }
        }

    }

    const restartByTypeHandler = (playingType) => {
        if(playingType === 'repeat'){
            startTime();
        } else if(playingType === 'sequence'){ 
            playNextClipHandler();
        }
	}

    const playPrevClipHandler = () => {
        // 이전 영상 재생 이벤트 핸들러
        var currentKey = props.dataKey;
        var playList = props.playList;

        $("[name='videoClips']").removeClass('active');
        //$("[name='videoClips']").css("backgroundColor","");

        let newKey = 0;
        let currentKeyIdx = 0;

        playList.forEach(function(item,idx){
            newKey = item.gameInfoId+''+item.inning+''+item.inningTb+''+item.batInningTurn+''+item.batPitchSeq;

            if(newKey == currentKey){
                currentKeyIdx = idx;
            }
        });

        var prevKeyIdx = currentKeyIdx - 1;
		var firstIdx = 0;

        if(prevKeyIdx >= firstIdx){
            havingVideoToPlayByRow(prevKeyIdx, playList, newKey);

        } else {
            //현재 재생중인 영상이 마지막 영상일 경우
            if(props.useLang === "en"){
                alert("The first video is currently playing.");
            } else {
                alert('맨 첫번째 영상이 재생중입니다.');
            }
            props.setPlaying(false);

        }
    }

    const playNextClipHandler = () => {
        //다음 영상 재생 이벤트 핸들러
        var currentKey = props.dataKey;
        var playList = props.playList;

        $("[name='videoClips']").removeClass('active');
        //$("[name='videoClips']").css("backgroundColor","");

        let newKey = 0;
        let currentKeyIdx = 0;

        playList.forEach(function(item,idx){
            newKey = item.gameInfoId+''+item.inning+''+item.inningTb+''+item.batInningTurn+''+item.batPitchSeq;

            if(newKey == currentKey){
                currentKeyIdx = idx;
            }
        });

        var nextKeyIdx = currentKeyIdx + 1;
		var lastIdx = _.size(playList)-1;

        if(nextKeyIdx <= lastIdx){
            havingVideoToPlayByRow(nextKeyIdx, playList, newKey);
            
        } else {
            //현재 재생중인 영상이 마지막 영상일 경우
            if(props.useLang === "en"){
                alert("Video list playback is complete");
            } else {
                alert('리스트 재생이 완료되었습니다.');
            }
            props.setPlaying(false);

        }

    }

    // 이전 또는 이후로 이동하면서 재생할 영상이 있는 경우 (로우 단위)
    const havingVideoToPlayByRow = (keyToMove, playList, newKey) => {
        var gameInfoId = props.dataKey.substring(0,6);
        var findPitch = "";
        var findVideo = "";
        var videoType = props.getVideoType();
        var videoArr = [];
        var infoArr = [];
        
        let itemKey = 0;

        playList.forEach(function(item,idx){
            newKey = item.gameInfoId+''+item.inning+''+item.inningTb+''+item.batInningTurn+''+item.batPitchSeq;

            if(idx == keyToMove){
                itemKey = newKey;
            }
        });

        findPitch = playList.find(function(pitch){
            return itemKey === pitch.gameInfoId+''+pitch.inning+''+pitch.inningTb+''+pitch.batInningTurn+''+pitch.batPitchSeq;
        });

        //넘어갈 이전 경기에 대해 영상유형 라디오 버튼 다시 설정
        props.videoInfos.map((item, index) => {
            if(item.gameInfoId == itemKey.substring(0,6)){
                videoArr.push(item.cVideoType);
            }
        });

        videoArr = videoArr.sort();
        props.setVideoTypeArr(videoArr);

        // 영상 최초 선택 시 영상 타입이 비어있을 경우 배열의 가장 첫번째 채워주기 (broadCast)
        if(videoType === ""){
            videoType = videoArr[0];
        }

        let pitchingTime = "";

        if(gameInfoId != itemKey.substring(0,6)) {
            //라디오 버튼 변경을 위해서 일단 (1)전체 해제 후 (2)원하는 버튼 선택으로 설정
            $("[name='videoTypeGroup']").removeClass("active");
            $("[name='videoTypeGroup'][value='"+videoArr[0]+"']").addClass("active");

            videoType = videoArr[0];
            pitchingTime = props.settingPitchingTime(findPitch, videoType);

            //넘어갈 경기가 다른날 경기일 경우
            findVideo = props.videoInfos.find(function (pitch) {
                var prevGameInfoId = pitch.gameInfoId;       
                return (itemKey.substring(0,6) === prevGameInfoId) && (videoArr[0] == pitch.cVideoType);
            });

            props.videoInfos.map((item, index) => {
                videoArr.map((videoType, idx) => {
                    if ((item.gameInfoId === itemKey.substring(0,6)) && (videoArr[idx] == item.cVideoType)){
                        if(pitchingTime < 0){
                            infoArr.push(videoType);
                        }
                    }
                });
            });

        } else {
            //넘어갈 경기가 같은날 경기일 경우
            findVideo = props.videoInfos.find(function (pitch) {
                var currentKey = pitch.gameInfoId;           
                return (currentKey === gameInfoId) && (videoType == pitch.cVideoType);
            });

            pitchingTime = props.settingPitchingTime(findPitch, videoType);

            props.videoInfos.map((item, index) => {
                videoArr.map((videoType, idx) => {
                    if ((item.gameInfoId === gameInfoId) && (videoArr[idx] == item.cVideoType)){
                        if(pitchingTime < 0){
                            infoArr.push(videoType);
                        }
                    }
                });
            });
        }

        props.setNonVideoTypeArr(infoArr);

        var selectedVideoPath = findVideo.videoPath;
        var selectedGoogleVideoPath = findVideo.googleVideoPath;
        var startTime = pitchingTime;

        var mp4VideoPath = selectedVideoPath.replace("/mp4hls/index.m3u8"," ");

        props.setDataKey(itemKey);
        //VideoScreen으로 넘겨줄 src 값을 set 해준다.
        props.setPath(selectedGoogleVideoPath);
        props.setAnotherPath(mp4VideoPath);

        props.settingClipPlay(startTime, findPitch);
    }

    // 이전 또는 이후로 이동하면서 재생할 영상이 있는 경우 (초 단위)
    const havingVideoToPlayBySec = (playList, newKey, keyIdx, playedSeconds, moveCode) => {
        var gameInfoId = props.dataKey.substring(0,6);
        var videoType = props.getVideoType();
        var findPitch = "";
        var findVideo = "";
        var videoArr = [];
        var infoArr = [];

        let itemKey = 0;

        playList.forEach(function(item,idx){
            newKey = item.gameInfoId+''+item.inning+''+item.inningTb+''+item.batInningTurn+''+item.batPitchSeq;

            if(idx == keyIdx){
                itemKey = newKey;
            }
        });

        findPitch = playList.find(function(pitch){
            return itemKey === pitch.gameInfoId+''+pitch.inning+''+pitch.inningTb+''+pitch.batInningTurn+''+pitch.batPitchSeq;
        });

        //넘어갈 다음 경기에 대해 영상유형 라디오 버튼 다시 설정
        props.videoInfos.map((item, index) => {
            if(item.gameInfoId == itemKey.substring(0,6)){
                videoArr.push(item.cVideoType);
            }
        });

        videoArr = videoArr.sort();
        props.setVideoTypeArr(videoArr);

        // 영상 최초 선택 시 영상 타입이 비어있을 경우 배열의 가장 첫번째 채워주기 (broadCast)
        if(videoType === ""){
            videoType = videoArr[0];
        }

        const pitchingTime = props.settingPitchingTime(findPitch, videoType);

        if(gameInfoId != itemKey.substring(0,6)) {                    
            //넘어갈 경기가 다른 경기일 경우
            findVideo = props.videoInfos.find(function (pitch) {
                var prevGameInfoId = pitch.gameInfoId;
                //경기ID가 같고 영상유형이 같은 항목 리턴              
                return (itemKey.substring(0,6) === prevGameInfoId) && (videoArr[0] == pitch.cVideoType);
            });

            props.videoInfos.map((item, index) => {
                videoArr.map((videoType, idx) => {
                    if ((item.gameInfoId === itemKey.substring(0,6)) && (videoArr[idx] == item.cVideoType)){
                        if(pitchingTime < 0){
                            infoArr.push(videoType);
                        }
                    }
                });
            });

        } else {
            //넘어갈 경기가 같은날 경기일 경우
            findVideo = props.videoInfos.find(function (pitch) {
                var currentKey = pitch.gameInfoId;
                //경기ID가 같고 영상유형이 같은 항목 리턴              
                return (currentKey === gameInfoId) && (videoType == pitch.cVideoType);
            });

            props.videoInfos.map((item, index) => {
                videoArr.map((videoType, idx) => {
                    if ((item.gameInfoId === gameInfoId) && (videoArr[idx] == item.cVideoType)){
                        if(pitchingTime < 0){
                            infoArr.push(videoType);
                        }
                    }
                });
            });
        }

        props.setNonVideoTypeArr(infoArr);

        var selectedVideoPath = findVideo.videoPath;
        var selectedGoogleVideoPath = findVideo.googleVideoPath;
        var startTime = pitchingTime;

        var mp4VideoPath = selectedVideoPath.replace("/mp4hls/index.m3u8"," ");

        // 재생할 하나 전 영상이 현재 재생중인 영상과 다른 경기인지 확인하는 변수 
        var prevGameYn = (gameInfoId != itemKey.substring(0,6));

        var result = settingJustPlay(startTime, findPitch, playedSeconds, prevGameYn, moveCode);

        //영상이 넘어가는 순간
        if(result == true){
            $("[name='videoClips']").removeClass('active');
            //$("[name='videoClips']").css("backgroundColor","");
            props.setDataKey(itemKey);
            props.setFrontTime(currentPlayingTime);
            props.setDuration(durationTime);
            props.setCaptionState(true);

            if(props.playing === false){
                // 영상이 넘어가는 순간에 일시정지가 되어 있는 상태였다면
                props.setIcon(faPlay);
                $("#screenController").animate({opacity:0}, 300);
                $('#playIcon').animate({opacity:0}, 300);
            }

            if(gameInfoId != itemKey.substring(0,6)){
                //라디오 버튼 변경을 위해서 일단 (1)전체 해제 후 (2)원하는 버튼 선택으로 설정
                //(하이라이트가 넘어가는 순간에 라디오 버튼 재설정)
                $("[name='videoTypeGroup']").removeClass("active");
                $("[name='videoTypeGroup'][value='"+videoArr[0]+"']").addClass("active");
                
                props.setPath(selectedGoogleVideoPath);
                props.setAnotherPath(mp4VideoPath);
            }

            //자막 텍스트 생성
            var videoText = props.trackTextMake(findPitch);
            $("#videoTextArea").html(videoText);
        }

    }

    //영상 재생 화면 클릭 이벤트 핸들러(재생/일시정지 설정)
    const screenHandler = (evt) => {
        stopLogging();
        intervalLogging(props.pathname);
        if(typeof props.dataKey == 'undefined' || props.dataKey == ''){
            //영상을 선택하지 않은 상태라면
            if(props.useLang === "en"){
                alert("Please select a video first");
            } else {
                alert("재생할 영상을 선택해주세요");
            }
        } else {
            //화면을 클릭했을 때 살짝 어두워지는 효과
            $("#screenController").animate({opacity:0.5}, 300);
            $('#playIcon').animate({opacity:0.8}, 300);

            if(props.timeoutCheck){
                clearTimeout(props.timeoutCheck);
            }
            const checkValue = setTimeout(() => {
                //화면을 클릭했을 때 살짝 어두워지는 효과
                $("#screenController").animate({opacity:0.5}, 300);
                $('#playIcon').animate({opacity:0.8}, 300);
    
                props.setPlaying(false);
                props.setIcon(faPause);
            }, 300000);
    
            props.setTimeoutCheck(checkValue);

            if(props.playing === true){
                //만약 영상이 재생중이라면
                props.setPlaying(false);
                props.setIcon(faPause);
            } else if(props.playing === false){
                //만약 영상이 일시정지 상태라면
                props.setPlaying(true);
                props.setIcon(faPlay);
                $("#screenController").animate({opacity:0}, 300);
                $('#playIcon').animate({opacity:0}, 300);
            } 
        }
	}

    //영상 재생이 되지 않을 때 videoPath를 다시 지정해주는 함수
    const videoLoadingError = () => {
        var arr = props.path.split('.')[1];
        
        // 최초 설정된 googleVideoPath 에러 발생 시 videoPath로 설정
        if(arr === "storage"){
            props.setPath(props.anotherPath);
        }
    }

    return(
        <div style={{position:"relative", display:"flex", justifyContent:"center", alignItems:"center"}}> 
            <div id="videoTextDiv" style={{position:"absolute", display:"flex", justifyContent:"center", backgroundColor:"rgba(0, 0, 0, 0.7)", width:"100%", height:"30px", top:"80%"}}>
                <span id="videoTextArea" style={{ zIndex:"1", opacity:"0", color:"#FFF", textAlign:"center", fontSize:"15px", padding:"3px 0px"}}></span>
            </div>
            <div id='screenController' onClick={screenHandler} className="video-js vjs-16-9" style={{position:"absolute", zIndex:"2", opacity:"0", top:"0"}}>
            </div>
            <FontAwesomeIcon onClick={screenHandler} id="playIcon" icon={props.icon} style={{position:"absolute", fontSize:"100px", color:"#FFF", zIndex:"3", opacity:"0"}}></FontAwesomeIcon>
            <div style={{position:"absolute"}}>
                {props.loading ? <FadeLoader color="#FFFFFF" height={15} width={5} radius={2} margin={2}/> : null}                
            </div>
            <div className="player-wrapper" style={{width:"100%"}}>
                <ReactPlayer
                    ref={videoRef}
                    className='react-player'
                    url={props.path}
                    playing={props.playing}
                    muted={true}
                    loop={false}
                    config={{
                        file:{
                            attributes:{
                                poster:"https://blog.kakaocdn.net/dn/Wddvk/btqAqhHHM3k/6hAu4NLbmUqKfR2SVJ4bM1/img.png"
                            }
                        }
                    }}
                    onStart={startTime}
                    onProgress={videoProgress}
                    onError={videoLoadingError}
                    width="100%"
                    height=""
                    playsinline
                ></ReactPlayer>
            </div>
        </div>
    )
}

